import { Context, createContext, RefObject } from 'react';

export interface IAlmanacContext {
  ref: RefObject<HTMLDivElement> | null;
  // setRef: (ref: RefObject<HTMLDivElement>) => void;
}

const defaultValue: IAlmanacContext = {
  ref: null,
  // setRef: (ref) => {}
}

export const AlmanacContext: Context<IAlmanacContext> = createContext(defaultValue);
